import React from 'react';

import {NucleotideType} from 'biojs/BioConstants';
import * as ExportDAO from 'exports/ExportDAO';
import {Tag} from 'folder-items/FileConstants';
import {formatRows} from 'util/ExportUtil';

function _formatDesc(s: string): string {
  s = s.replace(/\n/g, ' ');
  if (s.length > 100) {
    s = s.substring(0, 97);
    s += '...';
  }
  return s;
}

function _escapeTags(s: string): string {
  return s.replace(/("|:)/g, '\\$1');
}
function _tagsToString(tags: Array<Tag>): string {
  let str = '';
  for (const tag of Array.from(tags)) {
    if (tag.value) {
      str += `${_escapeTags(tag.name)}:${_escapeTags(tag.value)}`;
    } else {
      str += `${_escapeTags(tag.name)}`;
    }
    str += ' ';
  }
  return str.trim();
}

export interface OligoToFormat {
  name: string;
  bases: string;
  nucleotideType: NucleotideType;
  description?: string;
  tags?: Array<Tag>;
}

// Helper functions to export lists of sequence Primers
// These /do not take/ SequencePrimer objects. Instead, it takes an object where name and bases
// are directly exposed as properties (this allows the function to be used in cases where
// SequencePrimer objects are not directly exposed)

export function formatOligos(oligos: Array<OligoToFormat>, fmt: 'csv' | 'tsv'): string {
  const delimiter = (() => {
    switch (fmt) {
      case 'tsv':
        return '\t';
      case 'csv':
        return ',';
      default:
        throw new Error('Invalid format');
    }
  })();
  const rows = oligos.map((o) => {
    const row = [o.name, o.bases, o.nucleotideType];
    if (o.description) {
      row.push(_formatDesc(o.description));
    }
    if (o.tags && o.tags.length > 0) {
      row.push(_tagsToString(o.tags));
    }
    return row;
  });
  return formatRows(rows, delimiter);
}

export function downloadOligos({
  oligos,
  filename,
  format,
}: {
  oligos: Array<OligoToFormat>;
  filename: string;
  format?: 'csv' | 'tsv';
}): void {
  if (format == null) {
    format = 'csv';
  }
  ExportDAO.downloadStringContents(filename, formatOligos(oligos, format));
}

export function getOligoFilename(name: string, format?: string): string {
  if (format == null) {
    format = 'csv';
  }
  return `oligos ${name}.${format}`;
}

const IDT_ORDER_URL = 'http://www.idtdna.com/order/OrderEntry.aspx';
export const PRIMERS_COPIED_MSG = (
  <>
    Primers have been copied in tab-delimited format, which can be pasted into Excel or used in the "Paste"
    option on <a href={IDT_ORDER_URL}>IDT's order form</a>.
  </>
);
